import { DefaultButton, PrimaryButton, DirectionalHint, TooltipDelay } from "@fluentui/react";
import React, { useState, useContext, useEffect } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import {isMobile} from "react-device-detect";
import { downloadPdfReport } from "../../../../service/StudyReportService";
import SearchableDropdown from "../../../IssuesAndTroubleshooting/SearchDropdown";
import { dropdownStyles } from "../../helper/initialData";
import DownloadOptions from "./DownloadOptions";
import { Stack, Dropdown } from "@fluentui/react";
import userContext from "../../../../context/users/UserContext";
import { TAB_NAME, USERTYPES, NONXRAYMODALITIES, TOAST_TYPE } from "../../../../constants/Constants";
import CrossIcon from "../../../../components/navbar/nav-icons/CrossIcon";
import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import QCFailModal from "./QCFailModal";
import QCReasonModal from "./QCReasonModal";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import "../../styles/styles.css";
import UploadFistolugramModal from "./UploadFistolugramModal";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import AnnotatedImageModal, { FISTULOGRAM_CONFIG, FIBROID_CONFIG } from "./AnnotatedImageModal";
import QCPassConfirmModal from "./QCPassConfirmModal";
import PreliminaryActionModal from "../ReportModals/PreliminaryActionModal/PreliminaryActionModal";
import { keyImagesPresent } from "../../../StudyViewer/helpers/KeyImageUtility";
import { t } from "i18next";
import {
  getReportTemplatesData,
  downloadFistolugramImageAsBlob,
  downloadFibroidImageAsBlob,
} from "../../../../service/StudyReportService";
import { OpenInNewWindowIcon } from "@fluentui/react-icons-mdl2";
import loaderContext from "../../../../context/loader/LoaderContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { stylesForCustomSelect } from "../../../../components/CustomSelect"
import toastContext from "../../../../context/toast/ToastContext";
import MaskButton from "../../../StudyList/components/Mask/MaskButton";
import CopyReport from "../ReportActionButtons/CopyReport";
import ResetReport from "../ReportActionButtons/ResetReport";
import { isLLMAgentPresent } from "../../../../service/MaskImageService";
import PlatformHelper from "../../../../helpers/PlatformHelper";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";

const AlertSubmitSection = (props) => {
  const [clearRaiseAlert, setClearRaiseAlert] = useState(null);
  const [showResetReport, setShowResetReport] = useState(false);
  const [isRaiseAlertOpen, setIsRaiseAlertOpen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const [showPreliminaryActionModal, setShowPreliminaryActionModal] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsPortrait(window.innerHeight > window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    handlePreviewReport,
    handlePreviewReportWithKeyImage,
    handleSaveDraft,
    handleSaveReport,
    handleMarkAsPreliminary,
    handleReleasePreliminary,
    handleSubmitReport,
    handleQcPass,
    handleQcReturnButtonClick,
    handleRaiseAlertDropdown,
    userActionLoading,
    openQcReasonModal,
    setOpenQcReasonModal,
    openFistolugramUploadModal,
    openFistolugramModal,
    setOpenFistolugramModal,
    fistolugramFilePath,
    uploadFistolugramFunc,
    deleteFistolugramFunc,
    openFibroidModal,
    setOpenFibroidModal,
    fibroidFilePath,
    uploadFibroidFunc,
    deleteFibroidFunc,
    studyPatientSex,
    disableDownload,
    disablePreview,
    disableSave,
    disableSubmit,
    disableQCPass,
    disableQCReturn,
    disableRaiseAlert,
    disablePositiveNegative,
    reset,
    raiseAlertList,
    raiseAlertValue,
    setRaiseAlertValue,
    openQcModal,
    disableQCReason,
    isClientReportExist,
    patientReports,
    disableSubmitUntilQCReasonClick,
    isKeyImagesPresent,
    isTextAnnotationPresent,
    openQCPassConfirmModal,
    studyParentId,
    showPreliminaryActionPopup,
    allowDownloadReport,
    handleMarkAsSuspect,
    disableMarkAsSuspect,
    isChildStudyReportState,
    keyImagePresentStudyList,
    showMsWord,
    handleDownloadDoc,
    activeTab,
    formatterAgentEnabled,
    formattedReportUsed,
    hasAgenticReport,
    isExternal,
    reportDoneStatusState,
    reviewerId, reviewStatus,
    editorRef,
    handleModelChange,
    studyDescription,
    modality,
    disableEditReport,
  } = useContext(studyReportContext);

  const {
      handleDSRRegenerate,
    } = useContext(AgenticReportingContext);

  const annotationContext = useContext(AnnotationContext) || {};
  const { handleNegativeSubmitReport } = annotationContext; 
  const extReportRecieved = (props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true) ? false : props.extReportReived;
  const { getThemeColor,themeName,getAlterColor } = useContext(themeContext);
  // const { createAnnotationJson } = useContext(AnnotationContext);
  let [showInfo1, setShowInfo1] = useState(false);

  const { roles, username, authenticated, loadByUsername, userId, isActiveData, enableLlmReport} =
    useContext(userContext);

  const { loaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);


  const clearValue = () => {
    // console.log("test");
  };

  const updatedStylesDisable = {
    root: {
      // background:'#404040',
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      padding: 0,
    },
  };

  const updatedStylesEnable = {
    root: {
      height: "28px",
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesEnableMobileSuspect = {
    root: {
      height: "28px",
      minWidth: 0,
      padding: "0 6px",
      fontSize: "11px",
    },
  };

  const mobileCompactButton = {
    root: {
      height: "28px",
      minWidth: 0,
      padding: "0 8px",
      fontSize: "11px",
    },
  };

  
  const updatedStylesEnableMSWord = {
    root: {
      height: "28px",
      width: "90px",
      // left: "-5px"
      // borderRadius: "5px",
      // fontSize: "12px",
      // fontWeight: 600,
      // background: "#2F80ED",
      // border: "1px solid #2F80ED",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingSubmit = {
    root: {
      height: "28px",
      width: "80px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const updatedStylesWithFormattingQCPass = {
    root: {
      height: "28px",
      width: "85px",
    },
    rootHovered: {
      // background: "#2F80ED",
      // color: "white",
    },
  };

  const iconButtonStyles = {
    root: {
      height: "28px",
      minWidth: "40px",
      width: "40px",
      padding: 0,
    },
    icon: {
      fontSize: "16px",
    },
  };


  const hasRow1ActionButtons = () => {
    let count = 0;
    if (activeTab !== 3 && !disableMarkAsSuspect && !isChildStudyReportState && !PlatformHelper.isFahes()) count++;
    if (activeTab !== 3 && !disablePreview && !isChildStudyReportState) count++;
    if (activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && !disableDownload && !isChildStudyReportState) count++;
    if (!isMobile && activeTab !== 3 && !(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription)) && showMsWord && !PlatformHelper.isFahes() && !disableEditReport) count++;
    if (activeTab !== 3 && !disableQCReason && !isChildStudyReportState) count++;
    if (activeTab !== 3 && !disableQCPass && !isChildStudyReportState) count++;
    if (activeTab !== 3 && !disableQCReturn && !isChildStudyReportState) count++;
    if (activeTab === 3 && !disableEditReport && (isExternal || !NONXRAYMODALITIES.includes(props.modality))) count++;
    return isPortrait && count >= 3;
  };

  const checkForSaveButton = ()=>{
   
     return !disableSave && !isChildStudyReportState && activeTab !== 3 && !PlatformHelper.isFahes(); 
    
  }

  const checkForSubmitButton = (getThemeColor) => {
    return !disableSubmit && !isChildStudyReportState && activeTab !== 3 && !PlatformHelper.isFahes();
  }

  const checkForPositiveNegativeButton = (getThemeColor) => {
    return !disableSubmit && !disablePositiveNegative &&!isChildStudyReportState && activeTab !== 3 && PlatformHelper.isFahes();
  }

  const getRaiseAlertLabel = (value) => {
      let data = raiseAlertList;
      if(data != null && data != undefined && data?.length > 0){
        const result = data.find(item => item.value === value);
        if (result) {
          return result?.label
        }
        return value;
      }else{
        return null;
      }
  }

  useEffect(() => {
    const elements = document.getElementsByClassName("react-select__input-container");
  
    if (elements.length > 0 && window.location.href.includes("studylist")) {
      // Convert the HTMLCollection to an array and set the style for each element
      Array.from(elements).forEach(element => {
        element.style.color = getThemeColor("primary-color");
      });
    }
  },[raiseAlertValue,themeName])

  const checkForPeerReviewReportDownloadAvailable = () => {
    if(reviewerId != null && reviewStatus != 1){
      return true;
    }
    return false;
  }

  const checkForDownloadAvailable = () => {
    if(reviewerId != null && reviewerId == userId){
      return false;
    }
    return true;
  }

  if (isMobile && props.readOnly) {
    return (
      <div className="mobile-download-box-wrapper">
      {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) && 
        !disableDownload && 
        !isChildStudyReportState && (
          <div className="mobile-download-buttons">
          <DefaultButton
            text={t("button.download")}
            disabled={disableDownload}
            styles={updatedStylesDisable}
            onClick={() => {
              if (showInfo1) {
                // console.log("False");
                setShowInfo1(false);
              } else {
                // console.log("True");
                setShowInfo1(true);
              }
            }}
          />
        <DownloadOptions
          studyParentId={studyParentId}
          show={showInfo1}
          onClickOutside={() => setShowInfo1(false)}
          modality={props.modality}
          isKeyImagesPresent={
            props.isStudyList
              ? keyImagePresentStudyList
              : keyImagePresentStudyList || keyImagesPresent(props.keyImages)
          }
          isExtReportReceived={extReportRecieved}
          reportOptions={checkForDownloadAvailable()}
          peerReviewReportOptions={checkForPeerReviewReportDownloadAvailable()}
        />
      </div>)}
   
        </div>
    );
  } else {
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        height: hasRow1ActionButtons() ? "80px" : "42px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", 
        padding: props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true ? '8px' : '',
        width: "100%",
        // ...((enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && { paddingLeft: 0 })
      }}
    >
      {!isChildStudyReportState && <div className="ms-Grid-row" style={{ width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "4px" }}>




   
        

            {/* {enableLlmReport && isLLMAgentPresent(props.modality, studyDescription ) && (
              <div style={{ display: "flex", alignItems: "center"}} >
                <ReportTemplateIndicator/>
                <ResetReport/>
                <CopyReport/>

              </div>
            )} */}
           
          
          {/* Buttons: Row 1 = action buttons, Row 2 = Save / Submit */}
          <div className="bottom-button" style={{ display: "flex", flexDirection: hasRow1ActionButtons() ? "column" : "row", width: "100%", gap: hasRow1ActionButtons() ? "4px" : "6px", alignItems: hasRow1ActionButtons() ? "stretch" : "center" }}>

            {/* Row 1: Raise Alert + action buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px", flex: hasRow1ActionButtons() ? undefined : 1 }}>

            {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR) )  && !disableRaiseAlert && (
          <div
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4 parent-dropdown"
            style={{
               marginRight: "8px",
               minWidth: 0,
               ...(isMobile && { width: "120px", flex: "0 0 120px", maxWidth: "120px" }),
               ...((enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && { marginLeft: "-5px", paddingLeft: 0 })
            }}>
            {/* {raiseAlertValue != undefined && ( */}
            <CustomToolTipHost content={isRaiseAlertOpen ? undefined : (!raiseAlertValue ? t("placeholder.raise-alert") : undefined)} id="raise-alert-tooltip">
              <CreatableSelect
                menuPlacement="top"
                menuPosition="fixed"
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                onMenuOpen={() => setIsRaiseAlertOpen(true)}
                onMenuClose={() => setIsRaiseAlertOpen(false)}
                styles={{
                  ...stylesForCustomSelect(getThemeColor),
                  //menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menuPortal: (base) => ({ ...base, zIndex: 10000001 }),
                }}
                defaultValue={
                  raiseAlertValue != undefined &&
                  raiseAlertValue != null &&
                  raiseAlertValue != ""
                    ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                    : null
                }
                onChange={(ele) => {
                  handleRaiseAlertDropdown(ele);
                }}
                placeholder={t("placeholder.raise-alert")}
                isClearable
                options={raiseAlertList}
                components={{
                  Placeholder: ({ children, innerProps }) => (
                    <div
                      {...innerProps}
                      title={children}
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: "hsl(0, 0%, 50%)",
                        gridArea: "1/1/2/3",
                        marginLeft: "2px",
                        marginRight: "2px",
                        boxSizing: "border-box",
                      }}
                    >
                      {children}
                    </div>
                  ),
                }}
              />
            </CustomToolTipHost>
            {/* )} */}
          </div>
        )}
            {/* Raise Alert dropdown - moved to beginning of right side group */}
            {/* {(roles.includes(USERTYPES.RADIOLOGIST) || roles.includes(USERTYPES.SUPERVISOR)) && enableLlmReport && isLLMAgentPresent(props.modality, studyDescription ) && !disableRaiseAlert && (
              <div className="form-field" style={{ width: "100%", maxWidth: "150px", marginRight: "3%", fontSize: "14px" }}>
                <CreatableSelect
                  menuPlacement="auto"  
                  classNamePrefix="react-select" 
                  styles={stylesForCustomSelect(getThemeColor)} 
                  defaultValue={
                    raiseAlertValue != undefined &&
                    raiseAlertValue != null &&
                    raiseAlertValue != ""
                      ? { key: raiseAlertValue, label: getRaiseAlertLabel(raiseAlertValue) }
                      : null
                  }
                  onChange={(ele) => {
                    handleRaiseAlertDropdown(ele);
                  }}
                  placeholder={t("placeholder.raise-alert")}
                  isClearable
                  options={raiseAlertList}
                />
              </div>
            )} */}
            
            {/* Row 1 action buttons */}
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "6px" }}>
            {activeTab !== 3 && !disableMarkAsSuspect && !isChildStudyReportState && !PlatformHelper.isFahes() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto", ...(isMobile && { flexShrink: 0 }) }}>
                <DefaultButton
                  text={t("button.suspect")}
                  onClick={handleMarkAsSuspect}
                  disabled={disableMarkAsSuspect || !isActiveData}
                  styles={isMobile ? updatedStylesEnableMobileSuspect : updatedStylesEnable}
                />
              </div>
            )}

            {activeTab !== 3 && !disablePreview && !isChildStudyReportState && (
              <div className="download-box-wrapper form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.preview")}
                  disabled={disablePreview}
                  styles={updatedStylesDisable}
                  onClick={() => {
                    // Let the system decide: preview with key images if present, else plain report
                    const hasKeyImages = props.isStudyList
                      ? keyImagePresentStudyList
                      : keyImagePresentStudyList || keyImagesPresent(props.keyImages);
                    if (hasKeyImages) {
                      handlePreviewReportWithKeyImage(studyParentId);
                    } else {
                      handlePreviewReport(studyParentId);
                    }
                  }}
                />
              </div>
            )}

            {activeTab !== 3 && (allowDownloadReport || roles.includes(USERTYPES.ADMIN)) &&
              !disableDownload && !isChildStudyReportState && (
                <div className="download-box-wrapper form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                  <DefaultButton
                    text={t("button.download")}
                    disabled={disableDownload}
                    styles={updatedStylesDisable}
                    onClick={() => {
                      if (showInfo1) {
                        setShowInfo1(false);
                      } else {
                        setShowInfo1(true);
                      }
                    }}
                  />
                  <DownloadOptions
                    studyParentId={studyParentId}
                    show={showInfo1}
                    onClickOutside={() => {
                      setShowInfo1(false);
                    }}
                    modality={props.modality}
                    isKeyImagesPresent={props.isStudyList ? keyImagePresentStudyList : keyImagePresentStudyList || keyImagesPresent(props.keyImages)}
                    isExtReportReceived={extReportRecieved}
                  />
                </div>
              )
            }

            {!isMobile && activeTab !== 3 && !(enableLlmReport && isLLMAgentPresent(props.modality, studyDescription )) && showMsWord && !PlatformHelper.isFahes() && !disableEditReport &&(
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  onClick={() => {
                    handleDownloadDoc(studyParentId)
                  }}
                  iconProps={{iconName:"OpenInNewWindow"}}
                  text={`MS-Word`}
                  styles={updatedStylesEnableMSWord}
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCReason && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-reason")}
                  onClick={() => setOpenQcReasonModal(true)}
                  styles={updatedStylesDisable}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCPass && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-pass")}
                  styles={formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingQCPass : updatedStylesDisable}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleQcPass(
                      studyParentId,
                      props.keyImages,
                      props.qcData,
                      props.allTextToolAnnotation,
                      true,
                      false
                    )
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCPass && !isChildStudyReportState && formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 && hasAgenticReport && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-pass")}
                  styles={updatedStylesDisable}
                  onClick={() =>
                    handleQcPass(
                      studyParentId,
                      props.keyImages,
                      props.qcData,
                      props.allTextToolAnnotation,
                      true,
                      true
                    )
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab !== 3 && !disableQCReturn && !isChildStudyReportState && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.qc-return")}
                  styles={updatedStylesDisable}
                  onClick={() =>
                    handleQcReturnButtonClick(studyParentId, props.qcData)
                  }
                  disabled={!isActiveData}
                />
              </div>
            )}

            {activeTab === 3 && !disableEditReport && (isExternal || !NONXRAYMODALITIES.includes(props.modality)) && (
              <PrimaryButton
                className="report-button"
                text={t("studyviewer.regenerate-report")}
                styles={updatedStylesEnable}
                onClick={handleDSRRegenerate}
              />
            )}
            </div>
            </div>{/* end Row 1 */}

            {/* Row 2: Save Draft + Preliminary + Submit / Positive / Negative */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginLeft: hasRow1ActionButtons() ? undefined : "auto" }}>
            {checkForSaveButton() &&
              (roles.includes(USERTYPES.RADIOLOGIST) ||
                roles.includes(USERTYPES.TYPIST)) &&
              handleSaveDraft && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={t("button.save-draft")}
                  onClick={() =>
                    handleSaveDraft(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex
                    )
                  }
                  disabled={
                    !isActiveData || (isClientReportExist == true && patientReports.length == 0) || loaderRunning
                  }
                  styles={isMobile ? mobileCompactButton : updatedStylesDisable}
                />
              </div>
            )}

            {checkForSaveButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <DefaultButton
                  text={
                    roles.includes(USERTYPES.RADIOLOGIST) ||
                    roles.includes(USERTYPES.TYPIST)
                      ? t("button.preliminary")
                      : t("button.save")
                  }
                  onClick={() => {
                    const markAsPreliminary = () =>
                      (handleMarkAsPreliminary || handleSaveReport)(
                        true,
                        props.keyImages,
                        props.annotationData,
                        props.annotationDataAI,
                        props.allTextToolAnnotation,
                        props.activeViewportIndex
                      );
                    if (
                      roles.includes(USERTYPES.RADIOLOGIST) &&
                      showPreliminaryActionPopup
                    ) {
                      setShowPreliminaryActionModal(true);
                      return;
                    }
                    markAsPreliminary();
                  }}
                  disabled={
                    !isActiveData ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) ||
                    loaderRunning
                  }
                  styles={isMobile ? mobileCompactButton : updatedStylesDisable}
                />
              </div>
            )}

            {checkForSubmitButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.submit")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={isMobile ? mobileCompactButton : (formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? updatedStylesWithFormattingSubmit : updatedStylesEnable)}
                />
              </div>
            )}
            {checkForPositiveNegativeButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.negative")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleNegativeSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false,undefined,undefined,undefined,
                      false,
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={{
                      root: {
                        backgroundColor: "#4CAF50",
                        borderColor: "#4CAF50",
                      },
                      rootHovered: {
                        backgroundColor: "#43A047",
                        borderColor: "#43A047",
                      },
                      rootPressed: {
                        backgroundColor: "#388E3C",
                        borderColor: "#388E3C",
                      },
                    }}
               />
              </div>
            )}

            {checkForPositiveNegativeButton() && (
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl2" style={{ paddingLeft: 0, paddingRight: 0, width: "auto" }}>
                <PrimaryButton
                  text={t("button.positive")}
                  iconProps={{ iconName: formatterAgentEnabled && !formattedReportUsed && !isExternal && reportDoneStatusState !== 2 ? "AutoEnhanceOn" : "" }}
                  onClick={() =>
                    handleSubmitReport(
                      true,
                      props.keyImages,
                      props.annotationData,
                      props.annotationDataAI,
                      props.allTextToolAnnotation,
                      props.activeViewportIndex,
                      false,false,undefined,undefined,undefined,true,
                    )
                  }
                  disabled={
                    !isActiveData || (
                    disableSubmit ||
                    disableSubmitUntilQCReasonClick ||
                    (isClientReportExist == true && patientReports.length == 0) || loaderRunning)
                  }
                  styles={{
                      root: {
                        backgroundColor: "#FB8C00",
                        borderColor: "#FB8C00",
                      },
                      rootHovered: {
                        backgroundColor: "#F57C00",
                        borderColor: "#F57C00",
                      },
                      rootPressed: {
                        backgroundColor: "#EF6C00",
                        borderColor: "#EF6C00",
                      },
                    }}
                />
              </div>
            )}
            </div>{/* end Row 2 */}

          </div>{/* end bottom-button */}
        </div>{/* end inner flex div */}

        {openQCPassConfirmModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <QCPassConfirmModal
              keyImages={props.keyImages}
              qcData={props.qcData}
              allTextToolAnnotation={props.allTextToolAnnotation}
            />
          </div>
        )}

        <PreliminaryActionModal
          isOpen={showPreliminaryActionModal}
          onClose={() => setShowPreliminaryActionModal(false)}
          onMarkAsPreliminary={() => {
            setShowPreliminaryActionModal(false);
            (handleMarkAsPreliminary || handleSaveReport)(
              true,
              props.keyImages,
              props.annotationData,
              props.annotationDataAI,
              props.allTextToolAnnotation,
              props.activeViewportIndex
            );
          }}
          onRelease={() => {
            setShowPreliminaryActionModal(false);
            handleReleasePreliminary(studyParentId);
          }}
        />
        
        {openQcModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <QCFailModal keyImages={props.keyImages} qcData={props.qcData} allTextToolAnnotation={props.allTextToolAnnotation}/>
          </div>
        )}
        
        {/* OLD (Fistulogram upload modal): commented out, replaced by unified FistolugramModal below */}
        {/* {openFistolugramUploadModal && studyParentId != null && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <UploadFistolugramModal studyParentId={studyParentId} />
          </div>
        )} */}

        {/* Fistulogram + Fibroid modals — both render the same AnnotatedImageModal,
            differing only in config (endpoints, reference image, IDs). */}
        {openFistolugramModal && studyParentId != null && (
          <AnnotatedImageModal
            studyParentId={studyParentId}
            config={FISTULOGRAM_CONFIG}
            filePath={fistolugramFilePath}
            onClose={() => setOpenFistolugramModal(false)}
            downloadImageAsBlob={downloadFistolugramImageAsBlob}
            uploadFunc={uploadFistolugramFunc}
            deleteFunc={deleteFistolugramFunc}
          />
        )}

        {openFibroidModal && studyParentId != null && (
          <AnnotatedImageModal
            studyParentId={studyParentId}
            config={FIBROID_CONFIG}
            filePath={fibroidFilePath}
            patientSex={studyPatientSex}
            onClose={() => setOpenFibroidModal(false)}
            downloadImageAsBlob={downloadFibroidImageAsBlob}
            uploadFunc={uploadFibroidFunc}
            deleteFunc={deleteFibroidFunc}
          />
        )}
        
        {openQcReasonModal && (
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <QCReasonModal
              patientName={props.patientName}
              patientId={props.patientId}
            />
          </div>
        )}
      </div>}
      
      {isChildStudyReportState && 
        <div style={{ width: "100%" }} className="ms-Grid-row viewer-outline-heatmap-text">
          {t("string-literals.prior-study")}
        </div>
      }
  
    </div>
  );
}
};
  export default AlertSubmitSection;